import findLogo from '../images/find_logo.png';
import find1 from '../images/find1.png';
import find2 from '../images/find2.png';
import find3 from '../images/find3.png';
import find4 from '../images/find4.png';
import find5 from '../images/find5.png';
import find6 from '../images/find6.png';
import find7 from '../images/find7.png';
import find8 from '../images/find8.png';
import monaLogo from '../images/mona_logo.png';
import mona1 from '../images/mona1.png';
import mona2 from '../images/mona2.png';
import mona3 from '../images/mona3.png';
import mona4 from '../images/mona4.png';
import mona5 from '../images/mona5.png';
import mona6 from '../images/mona6.png';
import flowsLogo from '../images/flows_logo.png';
import flows1 from '../images/flows1.png';
import flows2 from '../images/flows2.png';
import flows3 from '../images/flows3.png';
import flows4 from '../images/flows4.png';
import flows5 from '../images/flows5.png';
import flows6 from '../images/flows6.png';
import flows7 from '../images/flows7.png';
import flows8 from '../images/flows8.png';

const products = [
  {
    id: "1",
    name: "Find Pro",
    image: findLogo,
    title: "It makes your life easier by providing easy access to thousands of service providers in more than 2000 categories such as transportation, cleaning, remodeling, painting and tutoring. Looking for a good cleaner, mover, electrician? ",
    description: "Find Pro is a completely free innovative platform that connects professional service providers and customers. It's easy to find electricians, plumbers, software developers, cleaners and much more! View professional profiles. Create your service requests. Communicate directly through the app. Make the best choice by reading trusted user reviews.Getting or providing services has never been easier with Find Pro. Download now and discover professionals!",
    websiteLink: "https://monapsikoloji.net/",
    appleStoreLink: "https://apps.apple.com/us/app/find-pro/id6740331723?platform=iphone",
    googlePlayLink: "https://play.google.com/store/apps/details?id=com.kok.findpro&pli=1",
    photos: [find1, find2, find3,find4,find5,find6,find7,find8]
  },
  {
    id: "2",
    name: "Mona Psikoloji Eğitim",
    image: monaLogo,
    title: "This full-stack web application is specifically designed to promote and support the operations of a consultancy center. We are happy to help you achieve your goal website by customizing these and other templates according to your wishes",
    description: "This full-stack web application is specifically designed to promote and support the operations of a consultancy center. Built using the MERN stack, it incorporates React for the frontend, MongoDB for the database, and Node.js with Express for the backend admin panel. The platform empowers psychologists and counselors to efficiently manage and update their blogs independently through a user-friendly admin panel, enhancing both visibility and engagement for the center’s services.",
    websiteLink: "https://mona-front-p25z.onrender.com",
    appleStoreLink: "https://mona-front-p25z.onrender.com",
    googlePlayLink: "https://mona-front-p25z.onrender.com",
    photos: [mona1, mona2, mona3,mona4,mona5,mona6]
  },
  {
    id: "3",
    name: "Flows",
    image: flowsLogo,
    title: "This social media application provides a platform for users to express their thoughts and ideas through videos. Meet young people with similar interests. Connect and exchange ideas with people from around the world.",
    description: "This social media application provides a platform for users to express their thoughts and ideas through videos. It allows users to connect with like-minded individuals and exchange ideas globally. Developed using Flutter, the project incorporates user management through Google and Apple tokens, along with efficient API handling via the Dio package. For notification and email services, we integrated OneSignal. The application follows the MVVM architectural pattern, ensuring a scalable and maintainable structure.",
    websiteLink: "https://apps.apple.com/tr/app/flows/id6479558212?l=tr",
    appleStoreLink: "https://apps.apple.com/tr/app/flows/id6479558212?l=tr",
    googlePlayLink: "https://play.google.com/store/apps/details?id=com.tt.flows&hl=en",
    photos: [flows1, flows2, flows3,flows4,flows5,flows6,flows7,flows8,]
  }
];

export default products;
